import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  &&& {
    dl {
      margin-bottom: 30px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;

const ConditionDiv = ({ className, children }) => {
  return <StyledDiv className={className}>{children}</StyledDiv>;
};

export default ConditionDiv;
